import { component } from "picoapp";
import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import styled from "styled-components";

let mysteryImg = "https://cdn.shopify.com/s/files/1/0110/7827/1033/files/iconmonstr-help-1.svg?v=1732310678"
let starting40 = "https://cdn.shopify.com/s/files/1/0110/7827/1033/files/Web-Product_Images-TRVL-Salmon-4.png?v=1741303996";
const getEtchStyles = (props) => {
  let desktopJugStyleString = "";
  let mobileJugStyleString = "";
  let desktopEtchStyleString = "";
  let mobileEtchStyleString = "";
  if (props.$font) {
    desktopEtchStyleString += `font-family: ${props.$font};`
  }
  switch (props.$jugType) {
    case "traveler-40oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 10%;"
      } else {
        desktopJugStyleString += "top: 29%"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:18px;" : "font-size:14px;"
        mobileEtchStyleString += "font-size:14px;"
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:20px;" : "font-size:16px;"
        mobileEtchStyleString += "font-size:16px;"
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:24px;" : "font-size:18px;"
        mobileEtchStyleString += "font-size:20px;"
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:28px;" : "font-size:23px;"
        mobileEtchStyleString += "font-size:24px;"
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:32px;" : "font-size:29px;"
        mobileEtchStyleString += "font-size:28px;"
      } else {
        desktopEtchStyleString += props.$direction === "vertical" ? "font-size:36px;" : "font-size:35px;"
        mobileEtchStyleString += "font-size:32px;"
      }
      break;
    case "traveler-32oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 18%;#designImg{width:105px;}"
        mobileJugStyleString += "top: 16%"
      } else {
        desktopJugStyleString += "top: 33%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:14px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 16px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:18px;";
        mobileEtchStyleString += "font-size: 20px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:23px;";
        mobileEtchStyleString += "font-size: 24px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:29px;";
        mobileEtchStyleString += "font-size: 28px;";
      } else {
        desktopEtchStyleString += "font-size:35px;"
        mobileEtchStyleString += "font-size: 32px;";
      }
      break;
    case "traveler-20oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 32%;left: 0px;#designImg{width:90px;}"
        mobileJugStyleString += "#designImg{width:85px;}"
      } else {
        desktopJugStyleString += "top: 46%;left: 0px;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:12px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:14px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 18px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:20px;";
        mobileEtchStyleString += "font-size: 22px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:26px;";
      } else {
        desktopEtchStyleString += "font-size:34px;"
        mobileEtchStyleString += "font-size: 30px;";
      }
      break;
    case "sport-32oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 20%;#designImg{width:95px;}"
        mobileJugStyleString += "top: 23%;"
      } else {
        desktopJugStyleString += "top: 33%;"
        mobileJugStyleString += "top: 38%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:12px;";
        mobileEtchStyleString += "font-size: 10px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:14px;";
        mobileEtchStyleString += "font-size: 10px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 14px;";

      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:18px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:23px;";
      } else {
        desktopEtchStyleString += "font-size:25px;"
      }
      
      break;
    case "stainless-64oz":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 42.5%;"
      } else {
        desktopJugStyleString += "top: 57.5%;"
        mobileJugStyleString += props.$direction === "vertical" ? "top:61%;" : "top: 58%;"
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:16px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:20px;";
        mobileEtchStyleString += "font-size: 16px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:24px;";
        mobileEtchStyleString += "font-size: 18px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:28px;";
        mobileEtchStyleString += "font-size: 20px;";
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:32px;";
        mobileEtchStyleString += "font-size: 24px;";
      } else {
        desktopEtchStyleString += "font-size:34px;"
        mobileEtchStyleString += "font-size: 26px;";
      }
      break;
    case "shkr":
      if (props.$etchType === "design") {
        desktopJugStyleString += "top: 30%; left: 8px;#designImg{width:90px;}";
      } else {
        if (props.$direction === "vertical") {
          if (props.$length >= 8) {
            desktopJugStyleString += "top: 51%; left: 8px;";
          } else {
            desktopJugStyleString += "top: 49%; left: 8px;";
          }
        } else {
          desktopJugStyleString += "top: 40%; left: 8px;";
        }
      }
      if (props.$length >= 14) {
        desktopEtchStyleString += "font-size:10px;";
      } else if (props.$length >= 12 && props.$length <= 13) {
        desktopEtchStyleString += "font-size:11px;";
        mobileEtchStyleString += "font-size: 12px;";
      } else if (props.$length >= 10 && props.$length <= 11) {
        desktopEtchStyleString += "font-size:13px;";
        mobileEtchStyleString += "font-size: 14px;";
      } else if (props.$length >= 8 && props.$length <= 9) {
        desktopEtchStyleString += "font-size:17px;";
        mobileEtchStyleString += "font-size: 16px;";
        if (props.$direction === "vertical") {
          desktopJugStyleString += "top: 51%;";
        }
      } else if (props.$length >= 6 && props.$length <= 7) {
        desktopEtchStyleString += "font-size:22px;";
        mobileEtchStyleString += "font-size: 20px;";
      } else {
        desktopEtchStyleString += "font-size:25px;"
        mobileEtchStyleString += "font-size: 23px;";
      }
      break;
  
    default:
      break;
  }
  if (props.$direction === "vertical") {
    desktopEtchStyleString += "transform: rotate(90deg);"
  }
  
  return `${desktopJugStyleString};
  #Result {
    ${desktopEtchStyleString};
  }
  @media screen and (max-width: 767px){
    ${mobileJugStyleString};
    #Result {
      ${mobileEtchStyleString};
    }
  }
  `
};
const StyledJugImage = styled.div.attrs(props => ({
  $jugType: props.$jugType,
  $etchType: props.$etchType,
  $length: props.$length || 1,
  $direction: props.$direction,
  $font: props.$font
}))`
  ${props => getEtchStyles(props)}
`
const fonts = [
  {name: "Arial", value: "Arial"}, 
  {name: "Times New Roman", value: "Times New Roman"}, 
  {name: "Verdana", value: "Verdana"}, 
  {name: "Impact", value: "Impact"}, 
  {name: "Cursive", value: "Snell Roundhand"}, 
  {name: "Lemon Jelly", value: "lemon jelly personal use"}, 
  {name: "Comic Sans", value: "Comic Sans MS"}, 
  {name: "Lovely Coffee", value: "lovely coffee"}, 
]


function StepOne({selectedJugType, setSelectedJugType, setSelectedJug, collections, selectedJug, loading}) {

  return (
    <li className="stepSection stepSection1" alt="step 1">
    <fieldset id='step-1' className=''>
      <legend id="selectedJugName" className="step-show">Step 1 - Select a size</legend>
      {!loading ? collections.map((coll, i) => (
        <button key={i}
        id={`step1_text${i+1}`} 
        className={`stepSpan stepSpan--1 step1_text step_text ${coll.handle === selectedJugType ? "is-active" : ""}`}
        onClick={(e)=> {
          setSelectedJugType(coll.handle)
          setSelectedJug(coll.products.find(prod => prod.title === selectedJug?.title));
        }}>
          <div className="icon-wrapper">
            <input tabIndex="-1" type="radio" name="collection-select" id={`${coll.handle}`} value={`${coll.handle}`} defaultChecked={selectedJugType === coll.handle} />
            <img className="step1-icon" alt={`${coll.products[0]?.variants[0]?.title || "Jug Type Selection"}`} src={coll.products[0]?.variants[0]?.featured_image?.src}/> 
          </div>
            <label htmlFor={`${coll.handle}`}>{coll.title}</label>
        </button>
      ))     
      : <div className="loading-message">Loading Products...</div>
    }
    </fieldset>
  </li>
  )
}
function StepTwo({collections, selectedJugType, setSelectedJug, selectedJug}) {

  return (
    <li className="stepSection stepSection2" alt="step 2">
    <fieldset>
      <legend id="selectedJugName" className="step-show">Step 2 - Select a color</legend>
      {
        collections.map((collection, i) => 
          {
            return (
              <ul key={i} id='' className={`jugSelection inner ${collection.handle === selectedJugType ? "is-active" : ""}`}>
                {collection.products?.map((prod, i) =>
                  <button
                  className={`ssImg ${selectedJug?.handle === prod.handle ? "is-active" : ""}`}
                  onClick={()=> setSelectedJug(prod)}
                  key={i}
                  >
                    <input tabIndex="-1" type="radio" name="product-select" id={`${prod.handle}`} value={`${prod.handle}`} defaultChecked={selectedJug?.handle === prod.handle} />
                    <img 
                      src={prod.variants[0]?.featured_image?.src}
                      alt={`${prod.variants[0]?.title || "Jug Selection"}`}
                    />
                    <label className="hidden-label" htmlFor={`${prod.handle}`}>{prod.title}</label>

                  </button> 
                )}
              </ul>
              )
          })
      }
    </fieldset>
    </li>
  )
}
function StepThree({selectedEtchType, setSelectedDesignCategory, setSelectedEtchType, selectedDesignCategory, etchings, setSelectedDesign, customText, setCustomText, selectedFont, setSelectedFont, textDirection, setTextDirection, customTextItem, selectedDesign}) {
  const handleInputChange = (value) => {
    const newValue = value.replace(/[^a-zA-Z0-9 \.,!?-]/g, '').replace(/\s+/g,' '); 
    setCustomText(newValue);
  };
  return (
    <li className="stepSection stepSection3" alt="3">

      <fieldset>
        <legend id="selectedDesignName" className="step-show">Step 3 - Select a design</legend>
        <div id='step-3' className=''> 
            <button className={`stepSpan ${selectedEtchType === "design" ? "is-active" : ""}`} onClick={()=> {
              setSelectedEtchType("design")
              setSelectedDesign(null);
              }}>
              <input tabIndex="-1" type="radio" name="design-type-select" id={`design-toggle`} value={`design-toggle`} defaultChecked={selectedEtchType === "design"} />
              <label htmlFor="design-toggle">DESIGNS</label>
            </button>
            <button className={`stepSpan ${selectedEtchType === "text" ? "is-active" : ""}`} onClick={()=> {
              setSelectedEtchType("text")
              setSelectedDesign(customTextItem);
              }}>
              <input tabIndex="-1" type="radio" name="design-type-select" id={`text-toggle`} value={`text-toggle`} defaultChecked={selectedEtchType === "text"} />
              <label htmlFor="text-toggle">TEXT</label>
            </button>
        </div>
      </fieldset>
    
    {selectedEtchType === "design" ? 
    
    <ul id='pickDesignToggle' className="designSelection inner" alt="pick a design">
      <fieldset>
        <div id="designSelectionOriginal">
          {!selectedDesignCategory ? 
          <legend className="designLabel step-show">Design Categories</legend>
          : ""
        }
          {etchings.length > 0 && etchings.map((prod, i) => (
              <div key={i} className={`tagWrap ${prod.handle === selectedDesignCategory?.handle ? "is-active" : ""}`} alt="tag wrap" >
                {prod.handle === selectedDesignCategory?.handle ? 
                  <div id="designSelection1" className="designSelection1">
                    <button id="backBTN" onClick={()=> setSelectedDesignCategory()}>
                      ⬅ Back
                    </button>
                    {prod.variants?.map((variant, i) => (
                        <button key={i} className="tagWrap--inner tagWrap--lvl2" name="" onClick={()=> setSelectedDesign(variant)}>
                          <input tabIndex="-1" type="radio" name="design-select" id={`${variant?.title}`} value={`${prod.handle}`} defaultChecked={selectedDesign?.handle === variant.handle} />
                          <label className="hidden-label" htmlFor={`${variant?.title}`}>{variant?.title}</label>
                          <img className="selectedVariantImg" src={variant.featured_image?.src} alt={`${variant?.title || "Etching Selection"}`}/>
                        </button>
                    ))}
                  </div>
                  :
                  <button className="tagWrap--lvl1" onClick={()=> setSelectedDesignCategory(prod)}>
                    <img className="selectedDesignImg" src={prod.variants[0]?.featured_image?.src} alt={`${prod.variants[0]?.title || "Etching Category Selection"}`}/>
                    <input tabIndex="-1" type="radio" name="design-select" id={`${prod?.title}`} value={`${prod?.handle}`} defaultChecked={selectedDesignCategory?.handle === prod.handle} />
                    <label className="selectedDesignTitle" htmlFor={`${prod?.title}`}>{prod.title}</label>
                  </button>
                }
              </div>
          ))}
        </div>
      </fieldset>
    </ul>
    : 
    <ul id='customTextToggle' className="designSelection inner">
      <div id="customTextWrapper">
        <div className="input-font-wrapper">
          <div className="input-wrapper">
            <input type="text" maxLength={10} className="tb" id="member" name="tb_" value={customText} onChange={(e)=> handleInputChange(e.target.value)}/>
          </div>
          <select id="font-dropdown" value={selectedFont} defaultValue={"init"} onChange={(e)=>setSelectedFont(e.target.value)}>
            <option disabled value="init">Select Font</option>
            {fonts.map((font,i) => (
              <option key={i} value={font.value}>{font.name}</option>
            ))}
          </select>
        </div>
        <div>
          <span className="toggle-step">Text Direction</span>
          <div className="toggle-wrapper">
            <button className={`stepSpan ${textDirection === "horizontal" ? "is-active" : ""}`} onClick={()=> setTextDirection("horizontal")}>Horizontal</button>
            <button className={`stepSpan ${textDirection === "vertical" ? "is-active" : ""}`} onClick={()=> setTextDirection("vertical")}>Vertical</button>
          </div>
        </div>
      </div>
    </ul>
    }
  </li>

  )
}
function StepFour({resetSelections, selectedJug, customText, selectedDesign, selectedEtchType, textDirection, selectedFont, customTextItem}) {
  let body = {
    items: []
  };
  let batchId = Math.floor(Math.random() * 1000000);
  if (selectedJug && selectedDesign) {
    
  
  if (selectedEtchType === "design") {
    body.items = [
      { 
        quantity: 1, 
        id: Number(selectedJug.variants[0]?.id), 
        properties: {
          etchInfo: {
          'etchType': 'design',
          'designId': selectedDesign.sku,
          '_batchId': batchId
        },
          'Customization': 'Laser Etch',
          'Notice': 'Final Sale'
        } 
      },
      { 
        quantity: 1, 
        id: Number(selectedDesign.id),
        properties: {
          etchInfo: {
            'etchType': 'design',
            'designId': selectedDesign.sku,
            '_batchId': batchId
          },
          'Customization': 'Laser Etch',
          'Notice': 'Final Sale'
        } 
      }
    ];
  } else {
    body.items = [
      { 
        quantity: 1, 
        id: Number(selectedJug.variants[0]?.id), 
        properties: {
          etchInfo: {
          'etchType': 'text',
          'text': customText,
          'textDirection': textDirection,
          'font': selectedFont,
          '_batchId': batchId
          },
          'Notice': 'Final Sale'
        } 
      },
      { 
        quantity: 1, 
        id: Number(customTextItem.id),
        properties: {
          etchInfo: {
            'etchType': 'text',
            'text': customText,
            'textDirection': textDirection,
            'font': selectedFont,
            '_batchId': batchId
            },
          'Notice': 'Final Sale'
        } 
      }
    ];
  }
}
  const handleSubmit = () =>{
    console.log("items:", body)
    fetch("/cart/add.js", {
      "method": "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    })
    .then(res => {
      res.json().then(res => {
        console.log("added", res);
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.querySelector("cart-drawer").show();
      })
    })
    .catch(err => {
      console.log("couldn't add", err);
    })
    resetSelections();
  }
  return (
    <li className="summarySection">
      <div className="reviewSelection inner">
        <p alt="summary" className="summary-title">Summary:</p>
        <div className="summaries">
          <div id='jugSummary'>
            <img id="summaryImg" src={selectedJug?.variants[0]?.featured_image?.src || mysteryImg} alt="Selected Jug Summary"/>
            <div>
              <p id='summaryJugTitle' alt="jug title">{selectedJug?.title || "Select a Size"}</p>
              <p id='summaryJugPrice' alt="jug price">{selectedJug?.variants[0]?.price || null}</p>
            </div>
          </div>
          <span>+</span>
          <div id='designSummary'>
            <>
              <img id="summaryDesign" src={selectedDesign?.featured_image?.src || mysteryImg} alt="Selected Design Summary"/>
              <div>
                {selectedEtchType === "text" ?
                  <p id='summaryDesignTitle' alt="design title">{customText ? selectedFont ? customText : "Select a Font" : "Enter your text" }</p>
                : 
                  <p id='summaryDesignTitle' alt="design title">{selectedDesign?.title || "Pick a Design"}</p>
                }
                <p id='summaryDesignPrice' alt="design price">{selectedDesign?.price || null}</p>
              </div>
            </>
          </div>
        </div>
        {selectedDesign && selectedJug ? 
        selectedEtchType === "text" && customText.trim() && selectedFont || selectedEtchType === "design" ?
        <>
        <p aria-label="total price" className="total-price">Total: <span id="totalPrice" aria-label="total price">${(Number(selectedDesign?.price) + Number(selectedJug?.variants[0]?.price)).toFixed(2)}</span></p>
        <button name="checkout"
          onClick={handleSubmit} 
          
          disabled={(selectedJug && selectedDesign) || (selectedJug && selectedEtchType === "text" && customText) ? false : true} 
          id="checkoutButton"
          alt="checkout button" 
          aria-label="checkout-button" 
          type="" 
          className="collection-add-to-cart action_button add_to_cart">
            ADD TO CART
        </button>
        </> : ""
        : ""}
      </div>
    </li>
  )
}
function Customizer() {
  let collectionIds = [288096583737,288096550969,288088490041,288096518201,288088522809,291721936953]
  let collectionHandles = ["traveler-40oz", "traveler-32oz", "traveler-20oz", "sport-32oz", "stainless-64oz"]
  let collectionTitles = ["Traveler (40oz)", "Traveler (32oz)", "Traveler (20oz)", "Sport (32oz)", "Sport (64oz)"]
  let etchingTitle = "Etching Designs"
  const [collections, setCollections] = useState([]);
  const [selectedJugType, setSelectedJugType] = useState("")
  const [selectedJug, setSelectedJug] = useState()
  const [selectedEtchType, setSelectedEtchType] = useState("design")
  const [etchings, setEtchings] = useState([]);
  const [selectedDesignCategory, setSelectedDesignCategory] = useState()
  const [selectedDesign, setSelectedDesign] = useState();
  const [customText, setCustomText] = useState("");
  const [textDirection, setTextDirection] = useState("horizontal");
  const [selectedFont, setSelectedFont] = useState();
  const [customTextItem, setCustomTextItem] = useState();
  const [loading, setLoading] = useState(false);

  const resetSelections = () => {
    setSelectedDesign();
    setSelectedDesignCategory();
    setSelectedEtchType("design");
    setSelectedJug();
    setSelectedFont();
    setSelectedJugType("");
    setCustomText("")
    setTextDirection("horizontal")
  }
  
  useEffect(() => {
    const fetchProducts = async () => {
    setLoading(true);
    for (let handle in collectionHandles) {
      try {
        const response = await fetch(`/collections/${collectionHandles[handle]}/products.json`, {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Access-Token': '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',
          },
        });

        const result = await response.json();
        const collection = result;
        collection.handle = collectionHandles[handle];
        collection.title = collectionTitles[handle]
        collection.products = collection.products.filter(prod => {
          const filteredVariants = prod.variants.filter(variant => variant.available && (!variant.title.includes("presale") && !variant.title.includes("pre-sale") && !variant.title.includes("Pre-sale") && !variant.title.includes("Presale") && !variant.title.includes("Pre-Sale")))
          prod.variants = filteredVariants;
          return prod.variants.length > 0;
        })
        console.log("coll", collection);
        setCollections((prev)=> [...prev, collection]);
      } catch (error) {
        console.log("errror", error)
      } 
    }
    try {
      const response = await fetch(`/collections/etching-designs/products.json`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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',
        },
        
      });

      const result = await response.json();
      setEtchings(result.products);
    } catch (error) {
      console.log("errror", error)
    } 
    try {
      const response = await fetch(`/products/custom-text.json`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Access-Token': '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',
        },
        
      });

      const result = await response.json();
      let variant = result.product.variants[0]
      variant.featured_image = result.product.image
      setCustomTextItem(variant);
    } catch (error) {
      console.log("errror", error)
    }
    setLoading(false); 
    };

    fetchProducts();
  }, []);
  return (
    <div>
      <div id="itemsAdded" alt="items added">
        Putting it all together for you!
        <br/>
        <img src="" alt="Packaging It Up" className="packagingGif"/>
      </div>
      
      <div className="custom-container">
        <div className="customImg">
          
          <>
            <img id="selectedImg" alt="Selected Jug" src={selectedJug?.variants[0]?.featured_image?.src || collections.find(coll => coll.handle === selectedJugType)?.products[0]?.variants[0]?.featured_image?.src || starting40} alt="etchedJug" className={selectedJug?.variants[0]?.featured_image?.src ? "selectedImg" : "selectedImg starting40"}/>
            <StyledJugImage className="customDesign" $jugType={selectedJugType} $font={selectedFont} $etchType={selectedEtchType} $direction={textDirection} $length={customText?.length}>
              {selectedEtchType === "design" ? selectedDesign && <img id="designImg" src={selectedDesign?.featured_image?.src} alt="customDesign"/> : <div id="Result" >{customText}</div>}
            </StyledJugImage>
          </> 
          
        </div>
        <div className="custom-navigation">
          <div className="headerWrapper">
            <h1 className="headerTitle" alt="header title">HydroJug You</h1>
            <p className="subTitle" alt="subtitle">Laser Etch a Stainless Sport, Shaker, or Traveler Below!</p>
            <p className="disclaimer">*All renderings are strictly a visual representation. Actual results may vary.</p>
          </div>
          <ul className="unstyled-list">
            <StepOne selectedJug={selectedJug} loading={loading} collections={collections} selectedJugType={selectedJugType} setSelectedJugType={setSelectedJugType} collectionTitles={collectionTitles} setSelectedJug={setSelectedJug}/>
            {collections && selectedJugType &&
              <StepTwo selectedJug={selectedJug} collections={collections} selectedJugType={selectedJugType} setSelectedJug={setSelectedJug}/>
            }
            {etchings && selectedJug && 
              <StepThree selectedDesign={selectedDesign} customTextItem={customTextItem} textDirection={textDirection} setTextDirection={setTextDirection} selectedFont={selectedFont} setSelectedFont={setSelectedFont} customText={customText} setCustomText={setCustomText} etchings={etchings} setSelectedDesign={setSelectedDesign} selectedEtchType={selectedEtchType} setSelectedEtchType={setSelectedEtchType} setSelectedDesignCategory={setSelectedDesignCategory} selectedDesignCategory={selectedDesignCategory}/>
            }
            {selectedDesign || selectedJug ?
                <StepFour resetSelections={resetSelections} customTextItem={customTextItem} textDirection={textDirection} selectedFont={selectedFont} selectedEtchType={selectedEtchType} selectedDesign={selectedDesign} selectedJug={selectedJug} customText={customText}/>
              : 
              <div className="emptyCart">Select a Jug and Design!</div>
            }
            <p className="disclosure" alt="disclosure" aria-label="disclosure final sale">
              *Customized Items Are Final Sale*
              <br />
              *Please Allow 2-3 Weeks For Processing*
            </p>
          </ul>
        </div>
      </div>
      
    </div>
  )
}
// const node = document.querySelector("#CustomizerHere");
// const root = createRoot(node)
// root.render(<Customizer/>)
export default component((node, ctx) => {
  const element = <Customizer node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
